import { useEffect, useRef, useState } from 'react';
import './MonthPicker.css';

interface MonthPickerProps {
    readOnly?: boolean;
    selectedMonthIndex: number;
    onMonthSelected: (selectedMonthIndex: number) => void;
}

export const months = () => {
    return Array.from({ length: 12 }, (_, i) => {
        const date = new Date(2000, i, 1); // Year 2000, month i (0-indexed)
        const monthName = date.toLocaleString('fr-FR', { month: 'long' });
        return monthName.charAt(0).toUpperCase() + monthName.slice(1);
    });
};

const MonthPicker: React.FC<MonthPickerProps> = ({ readOnly = false, selectedMonthIndex, onMonthSelected }) => {

    const [dropdownIsOpen, setIsOpen] = useState<boolean>(false);
    const [_selectedMonth, setSelectedMonth] = useState<number>(new Date().getMonth());
    const [isSelected, setIsSelected] = useState<boolean>(selectedMonthIndex == _selectedMonth);

    const dropdownRef = useRef<HTMLDivElement>(null);

    const toggleDropdown = () => {
        setIsOpen(!dropdownIsOpen);
    }

    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (selectedMonthIndex >= 0 && selectedMonthIndex < 12) {
            setSelectedMonth(selectedMonthIndex);
            setIsSelected(true);
        }
        else {
            setIsSelected(false);
        }
    }, [selectedMonthIndex]);

    return <div className={["dropdown", isSelected ? "selected" : ""].join(' ')} ref={dropdownRef}>

        <div className="dd-flex">

            <span className="selected-item" onClick={readOnly ? undefined : () => { setIsOpen(false); onMonthSelected(_selectedMonth); }}>{months()[_selectedMonth]}</span>
            {!readOnly && <div className="dropdown-btn" onClick={() => toggleDropdown()}>▼</div>}
            {dropdownIsOpen && <div className="dropdown-content">
                {months().map((m, i) =>
                    <div className="dropdown-item" onClick={readOnly ? undefined : () => { setIsOpen(false); onMonthSelected(i); }}>{m}</div>
                )}
            </div>}
        </div>
    </div>;

}

export default MonthPicker;